(function () {
  var config = window.BB_TN_GEO;
  if (!config || !config.enabled) return;

  var stateCodes = Array.isArray(config.states) ? config.states : ['TN', 'OK'];
  var stateSet = new Set(stateCodes.map(function (code) {
    return String(code || '').trim().toUpperCase();
  }).filter(Boolean));

  var modal = document.getElementById('TennesseeStateBlocker');
  if (!modal) return;

  function showModal() {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tennessee-state-blocker-open');
    document.body.classList.add('tennessee-state-blocker-open');
  }

  function hideModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tennessee-state-blocker-open');
    document.body.classList.remove('tennessee-state-blocker-open');
  }

  function matchesState(regionCode, countryCode) {
    if (String(countryCode || '').toUpperCase() !== 'US') return false;
    var value = String(regionCode || '').trim().toUpperCase();
    return stateSet.has(value);
  }

  function fetchGeo() {
    if (!window.BB_GEO) {
      return Promise.reject(new Error('Geo lookup unavailable'));
    }
    return window.BB_GEO.lookup(config);
  }

  function bindModalClose() {
    modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-tn-close]')) {
        hideModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        hideModal();
      }
    });
  }

  async function init() {
    bindModalClose();

    try {
      var geo = await fetchGeo();
      var countryCode = geo && (geo.country_code || geo.country);
      var regionCode = geo && (geo.region_code || geo.region);

      if (matchesState(regionCode, countryCode)) {
        showModal();
      }
    } catch (err) {
      console.warn('[TennesseeStateBlocker]', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
